import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SUBMIT,
  SUBMIT_SUCCESS,
  SUBMIT_FAILED,
} from './constants';

export const initAction = (id) => ({
  type: INIT,
  id,
});

export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});

export const submitAction = (userId: string, data: Record<string, unknown>) => ({
  type: SUBMIT,
  userId,
  data,
});

export const submitSuccessAction = (userId: string, data: Record<string, unknown>) => ({
  type: SUBMIT_SUCCESS,
  userId,
  data,
});

export const submitFailedAction = (error?: string | Error, errorCode?: string | number) => ({
  type: SUBMIT_FAILED,
  error,
  errorCode,
});
